import PropTypes from 'prop-types';

// import { Container } from './styles';

const UserDeactivate = ({ width = '20px', height = '20px', fill = 'none' }) => (
  <svg width={width} height={height} viewBox="0 0 50 50" fill={fill} xmlns="http://www.w3.org/2000/svg">
    <path d="M20 24.8571C23.031 24.8571 25.9379 23.6531 28.0812 21.5098C30.2245 19.3665 31.4286 16.4596 31.4286 13.4286C31.4286 10.3975 30.2245 7.49062 28.0812 5.34735C25.9379 3.20408 23.031 2 20 2C16.969 2 14.0621 3.20408 11.9188 5.34735C9.77551 7.49062 8.57143 10.3975 8.57143 13.4286C8.57143 16.4596 9.77551 19.3665 11.9188 21.5098C14.0621 23.6531 16.969 24.8571 20 24.8571ZM15.9196 29.1429C7.125 29.1429 0 38.2679 0 47.0625C0 48.5268 1.1875 49.7143 2.65179 49.7143H37.3482C38.8125 49.7143 40 48.5268 40 47.0625C40 38 34.5625 43.5 29.5 39C24.4375 34.5 29.5 29.1429 24 29.1429C14.5 29.1429 15.9196 29.1429 15.9196 29.1429Z" />
    <path d="M47 29C47 25.134 43.866 22 40 22C36.134 22 33 25.134 33 29C33 32.866 36.134 36 40 36V39C34.4772 39 30 34.5228 30 29C30 23.4772 34.4772 19 40 19C45.5228 19 50 23.4772 50 29C50 34.5228 45.5228 39 40 39V36C43.866 36 47 32.866 47 29Z" />
    <path d="M45.023 22.6057L47.1443 24.727L35.477 36.3943L33.3557 34.273L45.023 22.6057Z" />
  </svg>
);

UserDeactivate.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  fill: PropTypes.string,
};

export default UserDeactivate;
